// @ts-nocheck

(function (document, window) {
  'use strict';

  var antiClickjack;

  if (window.self === window.top) {
    antiClickjack = document.getElementById('anti-clickjack');
    antiClickjack.parentNode.removeChild(antiClickjack);
  } else {
    // remove all elements from the document, so nothing will ever be shown
    for (var i = 0; i < document.children.length; i++) {
      document.removeChild(document.children[i]);
    }
  }
})(document, window);
